import React, { useState, useEffect } from "react";
import "./AdmFeeSearch.css";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import SelectStudentFeeModal from "../FeeStudentModal/SelectStudentFeeModal";
import jsPDF from "jspdf";
import * as XLSX from "xlsx";

import Select from "react-select";
import { ApiUrl } from "../../../ApiUrl";
import ReactPaginate from "react-paginate";
 import "jspdf-autotable";

const FeeSearchPage = () => {
  const todayDate = new Date();
  const [viewReceipts, setViewReceipts] = useState(true); // Radio selection
  // const [viewOption, setViewOption] = useState("viewReceipts");
  // const [showTable, setShowTable] = useState(false);
  // const [loading, setLoading] = useState(true);
  const [classOptions, setClassOptions] = useState([]);
  // const [loading, setLoading] = useState(true);
  const [sectionOptions, setSectionOptions] = useState([]);
  const navigate = useNavigate();
  // const [startDate, setStartDate] = useState(null);
  // const [endDate, setEndDate] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [selectedStudent, setSelectedStudent] = useState(null);
  // const [studentName, setStudentName] = useState("");
  const [studentId, setStudentId] = useState("");
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);
  const [viewOption, setViewOption] = useState("viewReceipts");
  const [showTable, setShowTable] = useState(false);
  const [receiptsData, setReceiptsData] = useState([]);
  const [receipts, setReceipts] = useState([]);

  const [classId, setClassId] = useState(null);
  const [sectionId, setSectionId] = useState(null);
  const [studentName, setStudentName] = useState("");
  const [receiptNo, setReceiptNo] = useState("");
  const [startDate, setStartDate] = useState(todayDate);
  const [endDate, setEndDate] = useState(todayDate);
  const [bank, setBank] = useState(null);

  const [period, setPeriod] = useState(null); // Stores selected period
  const [periodOptions, setPeriodOptions] = useState([]);

  const handleNewClick = () => {
    navigate("/feecollection");
  };
  const [showUpdateModal, setShowUpdateModal] = useState(false);

  const [paymentMethodOptions, setPaymentMethodOptions] = useState([]);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const [cancelRemark, setCancelRemark] = useState("");

  //  const [bankOptions, setBankOptions] = useState([]);
  const [accountOptions, setAccountOptions] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [selectedAccount, setSelectedAccount] = useState(null); // State for cancel remark
  const [currentPage, setCurrentPage] = useState(0);
  const receiptsPerPage = 10;
  const [bankOptions, setBankOptions] = useState([]);
  const [accountDetails, setAccountDetails] = useState([]);

  

  const [selectedReceipt, setSelectedReceipt] = useState({
    receiptDate: "",
    amount: "",
    referenceDate: "",
    accountNumber: "",
    paymentMethodId: "",
    bankId: "",
    bankName: "",
  });

  // const handleSelectStudent = (selectedStudent) => {
  //   const fullName = [
  //     selectedStudent.studentBasicDetails.first_name || "",
  //     selectedStudent.studentBasicDetails.middle_name || "",
  //     selectedStudent.studentBasicDetails.last_name || "",
  //   ]
  //     .filter(Boolean)
  //     .join(" ");

  //   // Set studentId when selecting a student (we will use this for the search)
  //   setStudentId(selectedStudent.studentBasicDetails.id || "");
  //   setStudentName(fullName); // Set student name for display (not used for search)
  //   setClassId(selectedStudent.studentBasicDetails.addmitted_class || null);
  //   setSectionId(selectedStudent.studentBasicDetails.addmitted_section || null);

  //   handleCloseModal();
  // };

const handleSelectStudent = (selectedStudent) => {
  // Full name comes directly from API as `studentname`
  const fullName = selectedStudent.studentname || "";

  // Use studentId (actual student) instead of nested object
  setStudentId(selectedStudent.studentId || "");

  // Set student name for display
  setStudentName(fullName);

  // Set class and section from API response
  setClassId(selectedStudent.classId || null);
  setSectionId(selectedStudent.sectionId || null);

  handleCloseModal();
};

// const handleSelectStudent = (student) => {
//   setSelectedStudent({
//     id: student.id, // top-level id (196)
//     studentId: student.studentId, // keep if needed
//     admissionNo: student.school_admission_no || student.admissionNo || "",
//     barcode: student.barcode || "",
//     name: student.studentname || "",
//     class: student.classname || "",
//     section: student.sectionname || "",
//   });

//   handleCloseModal();
// };



  // You can adjust this to show more or fewer items per page
  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  // Calculate data for the current page
  const offset = currentPage * receiptsPerPage;
  const currentReceipts = receiptsData.slice(offset, offset + receiptsPerPage);
  const pageCount = Math.ceil(receiptsData.length / receiptsPerPage);

  const formatDateToLocal = (date) => {
    if (!date) return "";
    const year = date.getFullYear();
    const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
    const day = date.getDate().toString().padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const formatReceiptDateForTable = (value) => {
    if (!value) return "";

    // Keep plain YYYY-MM-DD as-is.
    if (typeof value === "string" && /^\d{4}-\d{2}-\d{2}$/.test(value)) {
      return value;
    }

    // Convert timestamp/ISO to local date only so it matches the receipt date shown to users.
    const dateObj = new Date(value);
    if (Number.isNaN(dateObj.getTime())) {
      return String(value);
    }

    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, "0");
    const day = String(dateObj.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  const handleClear = () => {
    setPeriod(null);
    setStudentName("");
    setReceiptNo("");
    setClassId(null);
    setSectionId(null);
    setStartDate(todayDate);
    setEndDate(todayDate);
    setViewOption("viewReceipts"); // Reset to default value
    setShowTable(false); // Hide the table
    setReceiptsData([]); // Clear the data in the table
  };

  const handleUpdateClick = async (receipt) => {
    const receiptId = receipt.receiptId;

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FEESRECIPTS/GetFEESRECIPTSBASEDONreceiptId/${receiptId}/`
      );
      const data = await response.json();

      if (data.message === "success!!") {
        const receiptData = data.data;

        // Set the selected receipt with fetched data
        setSelectedReceipt({
          receiptId: receiptData.receiptId, // Ensure you include receiptId here
          receiptDate: formatReceiptDateForTable(receiptData.receipt_date),
          amount: receiptData.amount,
          referenceDate: formatReceiptDateForTable(receiptData.reference_date),
          // paymentMethod: receiptData.payment_method,
          paymentMethodId: receiptData.payment_methodId || null,
          bankId: receiptData.bankId,
          accountNumber: receiptData.bank_account || "",
          paymentReference: receiptData.payment_reference || "",
        });

        setShowUpdateModal(true); // Show the modal after data is fetched
      } else {
        alert("Failed to fetch receipt data.");
      }
    } catch (error) {
      console.error("Error fetching receipt data:", error);
    }
  };

  // Handle input changes in the form
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setSelectedReceipt((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}BANK/GetAllbankList/`);
        const result = await response.json();

        if (result.message === "Success") {
          // Map API response to the format React Select needs
          const options = result.data.map((bank) => ({
            value: bank.id, // Bank ID as the value
            label: bank.bankname, // Bank name as the label
          }));
          setBankOptions(options);
        } else {
          console.error("Failed to fetch banks:", result.message);
        }
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    fetchBanks();
  }, []);

 

  useEffect(() => {
    if (selectedReceipt && selectedReceipt.bankId) {
      const fetchAccountDetails = async () => {
        try {
          const response = await fetch(
            `${ApiUrl.apiurl}Account_Details/GetAccountDetailsBasedOnBankId/${selectedReceipt.bankId}/`
          );
          const result = await response.json();

          if (result.message === "success!!") {
            const accountOptions = result.data.map((account) => ({
              value: account.bank_account,
              label: account.bank_account.toString(),
            }));
            setAccountDetails(accountOptions);
          } else {
            console.error("Failed to fetch account details:", result.message);
          }
        } catch (error) {
          console.error("Error fetching account details:", error);
        }
      };

      fetchAccountDetails();
    }
  }, [selectedReceipt]);

  // Handle bank selection
  const handleBankSelect = (selectedOption) => {
    setSelectedReceipt((prevState) => ({
      ...prevState,
      bankId: selectedOption ? selectedOption.value : "",
    }));
  };


  // Handle Search Function
  const handleSearch = async () => {
    const isViewReceipts = viewOption === "viewReceipts";
    // Fetch academicSessionId from local storage
    const academicSessionId = localStorage.getItem("academicSessionId");

    if (!academicSessionId) {
      alert("Academic session ID not found.");
      return;
    }

    // Access the studentId from state (we are filtering by studentId only)
    const studentIdValue = studentId || ""; // Ensure it's being accessed properly

    const formattedStartDate = formatDateToLocal(startDate);
    const formattedEndDate = formatDateToLocal(endDate);

    // Updated API URL: filter by studentId only, not by studentName
    const apiUrl = `${
      ApiUrl.apiurl
    }FEESRECIPTS/GetFilterFeeReceipts/?academic_year_id=${academicSessionId}&view_receipt=${isViewReceipts}&view_cancel_receipt=${!isViewReceipts}${
      studentIdValue ? `&studentId=${studentIdValue}` : ""
    }${classId ? `&classId=${classId}` : ""}${
      sectionId ? `&sectionId=${sectionId}` : "" // Ensure sectionId is included if it's set
    }${receiptNo ? `&receiptNo=${receiptNo.toString().replace(/^RC/i, "").trim()}` : ""}${
      formattedStartDate ? `&receipt_from=${formattedStartDate}` : ""
    }${formattedEndDate ? `&receipt_to=${formattedEndDate}` : ""}${
      period ? `&feePeriod=${period}` : ""
    }`;

    try {
      const response = await fetch(apiUrl);
      const result = await response.json();

      if (
        response.ok &&
        result.message === "success" &&
        Array.isArray(result.data)
      ) {
        const filteredData = result.data.map((item) => ({
          ...item,
          receiptDate: formatReceiptDateForTable(
            item.receiptDate || item.receipt_date
          ),
        }));
        setReceiptsData(filteredData);
        setShowTable(true);
        if (filteredData.length > 0) {
          setSelectedReceipt(filteredData[0]);
        } else {
          setSelectedReceipt(null);
        }
      } else {
        console.error("Failed to fetch data:", result.message);
        setReceiptsData([]);
        setShowTable(false);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
      setReceiptsData([]);
      setShowTable(false);
    }
  };

  // Export to Excel function
  const exportToExcel = () => {
    if (receiptsData.length > 0) {
      const ws = XLSX.utils.json_to_sheet(receiptsData); // Convert JSON data to a worksheet
      const wb = XLSX.utils.book_new(); // Create a new workbook
      XLSX.utils.book_append_sheet(wb, ws, "Receipts"); // Append the worksheet to the workbook
      XLSX.writeFile(wb, "Receipts_Data.xlsx"); // Write the Excel file
    } else {
      alert("No data available to export!");
    }
  };

  useEffect(() => {
    // Fetch payment methods from API
    const fetchPaymentMethods = async () => {
      try {
        const response = await fetch(
          `${ApiUrl.apiurl}PAYMENTMETHOD/GetAllpaymentmethodList/`
        );
        const result = await response.json();
        if (result.message === "Success" && result.data) {
          // Map data to the format React Select expects
          const options = result.data.map((method) => ({
            value: method.id,
            label: method.paymentmethoddesc,
          }));
          setPaymentMethodOptions(options);
        }
      } catch (error) {
        console.error("Error fetching payment methods:", error);
      }
    };

    fetchPaymentMethods();
  }, []);

  // Modal handling functions
  const handleOpenModal = () => setShowModal(true);
  const handleCloseModal = () => setShowModal(false);


  const handleOptionChange = (event) => {
    setViewOption(event.target.value);
    setShowTable(false); // Reset table view when switching options
  };

  useEffect(() => {
    const fetchPeriods = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Periods/GetAllPeriods/`);
        const result = await response.json();

        if (result.message === "success") {
          // Map API response to the format React Select needs
          const options = result.data.map((period) => ({
            value: period.id, // period ID as the value
            label: period.period_name, // period name as the label
          }));
          setPeriodOptions(options);
        } else {
          console.error("Failed to fetch periods:", result.message);
        }
      } catch (error) {
        console.error("Error fetching periods:", error);
      }
    };

    fetchPeriods();
  }, []);

  useEffect(() => {
    const fetchClassData = async () => {
      try {
        const response = await fetch(`${ApiUrl.apiurl}Class/GetAllClass`);
        const data = await response.json();

        if (data.message === "Success") {
          const formattedClasses = data.data.map((classItem) => ({
            value: classItem.id,
            label: classItem.classname,
          }));
          setClassOptions(formattedClasses);
        } else {
          console.error("Failed to fetch classes: ", data.message);
        }
      } catch (error) {
        console.error("Error fetching class data:", error);
      }
    };

    fetchClassData();
  }, []); // Empty dependency array ensures this runs only once
  // Empty dependency array ensures this runs only once

  // Fetch section data dynamically when classId changes
  // Fetch section data dynamically when classId changes

  useEffect(() => {
    const fetchSectionData = async () => {
      if (!classId) {
        setSectionOptions([]); // Clear sections if no class selected
        return;
      }

      console.log("Fetching sections for classId:", classId); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${classId}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [classId]);

  // Trigger when classId changes
  // Trigger when classId changes

  // Function to handle the modal opening
  // const handleUpdateClick = (receipt) => {
  //   setSelectedReceipt(receipt);
  //   setShowUpdateModal(true); // Show the modal
  // };

  // Function to handle closing the modal
  const handleCloseReceiptModal = () => {
    setShowUpdateModal(false); // Hide the modal
  };

  const handleSelectChange = (selectedOption, fieldName) => {
    setSelectedReceipt({
      ...selectedReceipt,
      [fieldName]: selectedOption ? selectedOption.value : "", // Update the selected field with the chosen value
    });
  };

  // Function to handle the Cancel link click
  const handleCancelClick = (e, receipt) => {
    e.preventDefault(); // Prevent default link behavior
    setSelectedReceipt(receipt); // Set the selected receipt
    setShowCancelModal(true); // Show the cancel modal
  };

  const handleSaveUpdate = async () => {
    if (!selectedReceipt || !selectedReceipt.receiptId) {
      console.error(
        "Selected receipt is missing or doesn't have a valid receiptId",
        selectedReceipt
      );
      alert("Receipt ID is missing.");
      return; // Exit if receipt ID is missing
    }

    const receiptId = selectedReceipt.receiptId;
    console.log("Using receiptId:", receiptId); // Debugging line

    // Prepare the request body
    // const requestBody = {
    //   receiptdate: selectedReceipt.receiptDate,
    //   paymentMethod: selectedReceipt.paymentMethodId, // fixed here
    //   payment_reference: selectedReceipt.paymentReference,
    //   reference_date: selectedReceipt.referenceDate,
    // };
    

    // // If the payment method is Cash (paymentMethod 1), set bankId and account_number to null
    // if (selectedReceipt.paymentMethod === 1) {
    //   // 1 represents Cash
    //   requestBody.bankId = null;
    //   requestBody.account_number = null;
    // } else {
    //   // If the payment method is not Cash, include bankId and account_number
    //   requestBody.bankId = selectedReceipt.bankId;
    //   requestBody.account_number = selectedReceipt.accountNumber;
    // }


    const requestBody = {
      receiptdate: selectedReceipt.receiptDate,
      paymentMethod: selectedReceipt.paymentMethodId,
      payment_reference: selectedReceipt.paymentReference,
      reference_date: selectedReceipt.referenceDate,
      bankId:
        selectedReceipt.paymentMethodId === 1 ? null : selectedReceipt.bankId,
      account_number:
        selectedReceipt.paymentMethodId === 1
          ? null
          : parseInt(selectedReceipt.accountNumber),
    };
    
    

    try {
      const response = await fetch(
        `${ApiUrl.apiurl}FEESRECIPTS/updatepaymentdetailsbasedonreceipt/${receiptId}/`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestBody),
        }
      );

      const data = await response.json();

      // Check for both success messages
      if (
        data.message === "success!!" ||
        data.message === "payment receipt Update successfully!!"
      ) {
        alert("Receipt updated successfully!");
        setShowUpdateModal(false); // Hide the update modal
      } else {
        alert("Failed to update receipt.");
      }
    } catch (error) {
      console.error("Error updating receipt:", error);
      alert("There was an error updating the receipt.");
    }
  };

  const handleCancelSave = async () => {
    // Check if the cancel remark is provided
    if (!cancelRemark) {
      alert("Please provide a cancel remark.");
      return;
    }

    const data = {
      receiptId: selectedReceipt.receiptId, // Get receipt ID from the selected receipt
      cancel_remark: cancelRemark, // Use the cancel remark state
    };

    try {
      // Call the API to save the cancellation
      const response = await fetch(
        `${ApiUrl.apiurl}FEESRECIPTS/FeeReceiptsCancelCreate/`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(data),
        }
      );

      const result = await response.json();
      if (response.ok) {
        // Handle success
        alert("Cancellation saved successfully!");

        // Immediately update the receipts state
        setReceipts((prevReceipts) =>
          prevReceipts.filter(
            (receipt) => receipt.receiptId !== selectedReceipt.receiptId
          )
        );

        setShowCancelModal(false); // Close modal
        setSelectedReceipt(null); // Clear selected receipt
        setCancelRemark(""); // Clear remark

        // Refresh the page
        window.location.reload();
      } else {
        // Handle error
        alert(result.message || "Failed to save cancellation.");
      }
    } catch (error) {
      console.error("Error calling API:", error);
      alert("An error occurred. Please try again.");
    }
  };

  // Function to handle clearing fields (optional)
  const handleCancelClear = () => {
    setCancelRemark("");
    // Reset any necessary states here
  };

  // Function to close the modal without saving
  const handleCancelCloseButton = () => {
    setShowCancelModal(false); // Close cancel modal
    setSelectedReceipt(null); // Clear selected receipt
    setCancelRemark(""); // Clear the cancel remark
  };



const handleReceiptLinkClick = async (receiptNo) => {
  const academicSessionId = localStorage.getItem("academicSessionId");

  if (!academicSessionId) {
    alert("Academic session ID not found.");
    return;
  }

  try {
    const response = await fetch(
      `${ApiUrl.apiurl}FEESRECIPTS/GetFeeReceiptsBasedOnReceiptNo/${receiptNo}/${academicSessionId}`
    );
    const result = await response.json();

    if (response.ok && result.receipt_data) {
      const data = result.receipt_data;
      const receiptDate = formatReceiptDateForTable(data.receipt_date);
      const doc = new jsPDF("portrait", "mm", "a4");

      // --- Load image ---
      const toBase64 = (url) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.crossOrigin = "Anonymous";
          img.onload = () => {
            const canvas = document.createElement("canvas");
            canvas.width = img.width;
            canvas.height = img.height;
            const ctx = canvas.getContext("2d");
            ctx.drawImage(img, 0, 0);
            resolve(canvas.toDataURL("image/jpeg"));
          };
          img.onerror = (err) => reject(err);
          img.src = url;
        });

      try {
        const sparshLogo = await toBase64("/Assets/sparsh.jpeg");
        doc.addImage(sparshLogo, "JPEG", 10, 10, 20, 20);
      } catch (error) {
        console.error("Error adding image:", error);
      }

      // --- Header ---
      const pageWidth = doc.internal.pageSize.getWidth();
      doc.setFont("Helvetica", "bold");
      doc.setFontSize(16);
      const headerText = "Sparsh College of Nursing and Allied Sciences";
      const textWidth =
        (doc.getStringUnitWidth(headerText) * doc.internal.getFontSize()) /
        doc.internal.scaleFactor;
      const textX = (pageWidth - textWidth) / 2;
      doc.text(headerText, textX, 22);

      doc.setFontSize(12);
      doc.text("Fee Receipt", pageWidth / 2, 30, { align: "center" });

      // --- Receipt Info Table ---
      const receiptDetails = [
        ["Receipt No", data.receipt_no, "Section", data.sectionname],
        ["Receipt Date", receiptDate, "Father's Name", data.fathername],
        ["Student Name", data.studentname, "Fee Period", data.feeperiods],
        ["Admission No", data.admission_no, "Amount", data.amount.toFixed(2)],
        ["Class", data.classname, "", ""],
      ];

      doc.autoTable({
        startY: 35,
        body: receiptDetails,
        theme: "grid",
        styles: { fontSize: 11, fontStyle: "bold" },
        margin: { left: 15 },
        tableWidth: 180,
      });

      // --- Fee Elements Table ---
      const feeElements = Object.values(data.payment_element_list).map(
        (el, index) => [index + 1, el.element_name, el.amount.toFixed(2)]
      );
      feeElements.push(["", "Total", data.amount.toFixed(2)]);

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 8,
        head: [["Sr. No.", "Element", "Amount"]],
        body: feeElements,
        theme: "grid",
        styles: { fontSize: 11, fontStyle: "bold" },
        columnStyles: { 2: { halign: "right" } },
        margin: { left: 15 },
        tableWidth: 180,
      });

      // --- Payment Method Table ---
      const paymentData = [
        [data.payment_method, data.payment_reference, data.amount.toFixed(2)],
      ];

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 8,
        head: [["Payment Method", "Payment Reference", "Amount"]],
        body: paymentData,
        theme: "grid",
        styles: { fontSize: 11, fontStyle: "bold" },
        columnStyles: { 2: { halign: "right" } },
        margin: { left: 15 },
        tableWidth: 180,
      });

      // --- Summary Table ---
      const summary = [
        ["Total Session Fee", data.total_academic_year_fees.toFixed(2)],
        ["Total Paid", data.total_paid.toFixed(2)],
        ["Total Balance", data.remaining_amount.toFixed(2)],
      ];

      doc.autoTable({
        startY: doc.lastAutoTable.finalY + 8,
        body: summary,
        theme: "grid",
        styles: { fontSize: 11, fontStyle: "bold" },
        columnStyles: { 1: { halign: "right" } },
        margin: { left: 15 },
        tableWidth: 180,
      });

      // --- Open PDF in new tab ---
      const pdfBlob = doc.output("blob");
      const blobUrl = URL.createObjectURL(pdfBlob);
      window.open(blobUrl, "_blank");
    } else {
      alert(result.message || "Failed to fetch receipt details.");
    }
  } catch (error) {
    console.error("Error fetching receipt details:", error);
    alert("An error occurred. Please try again.");
  }
};


  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "0px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                FEE SEARCH
              </p>
              {/* Adding a border around all buttons */}
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleNewClick}
                  >
                    New
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleSearch}
                  >
                    Search
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={() => navigate("/admin/dashboard")}

                    // onClick={handleCloseButton}
                  >
                    Close
                  </button>
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{
                      width: "150px",
                    }}
                    onClick={exportToExcel}
                  >
                    Export to Excel
                  </button>
                </div>
              </div>

              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-md-3 mb-3">
                        <label htmlFor="period" className="form-label">
                          Period
                        </label>
                        <Select
                          className="detail"
                          // classNamePrefix="react-select"
                          options={periodOptions} // Use the fetched period options
                          placeholder="Select Period"
                          value={
                            period
                              ? {
                                  value: period,
                                  label: periodOptions.find(
                                    (option) => option.value === period,
                                  )?.label,
                                }
                              : null
                          } // Select the value if available
                          onChange={(selectedOption) =>
                            setPeriod(
                              selectedOption ? selectedOption.value : null,
                            )
                          } // Update period state
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="student-name" className="form-label">
                          Student Name
                        </label>
                        <div className="d-flex align-items-center">
                          <input
                            type="text"
                            className="form-control detail"
                            placeholder="Enter student name"
                            value={studentName}
                            onChange={(e) => setStudentName(e.target.value)}
                          />
                          <button
                            type="button"
                            className="btn btn-primary ms-2 mb-0 mt-0"
                            onClick={handleOpenModal}
                            style={{ width: "50px", padding: "3px" }}
                          >
                            ...
                          </button>
                        </div>

                        <SelectStudentFeeModal
                          show={showModal}
                          handleClose={handleCloseModal}
                          onSelectStudent={handleSelectStudent}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="receipt-no" className="form-label">
                          ReceiptNO
                        </label>
                        <input
                          type="text"
                          className="form-control detail"
                          placeholder="Enter Receipt No"
                          value={receiptNo}
                          onChange={(e) => setReceiptNo(e.target.value)}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>

                        <Select
                          options={classOptions}
                          // classNamePrefix="react-select"
                          className="detail"
                          placeholder="Select Class"
                          value={
                            classOptions.find(
                              (option) => option.value === classId,
                            ) || null
                          } // Match the selected class
                          onChange={(selectedOption) =>
                            setClassId(
                              selectedOption ? selectedOption.value : null,
                            )
                          }
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          className="detail"
                          classNamePrefix="react-select"
                          placeholder="Select Section"
                          value={
                            sectionOptions.find(
                              (option) => option.value === sectionId,
                            ) || null
                          }
                          onChange={(selectedOption) => {
                            console.log(
                              "Selected sectionId:",
                              selectedOption ? selectedOption.value : null,
                            ); // Debugging
                            setSectionId(
                              selectedOption ? selectedOption.value : null,
                            );
                          }}
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="d-flex align-items-center">
                            Date From
                          </label>
                        </div>
                        <div style={{ position: "relative" }}>
                          <DatePicker
                            selected={startDate}
                            onChange={(date) => setStartDate(date)}
                            className="form-control detail w-100"
                            wrapperClassName="w-100"
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Select Date"
                            style={{ paddingRight: "36px" }}
                          />
                          <FontAwesomeIcon
                            icon={faCalendarAlt}
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#6c757d",
                              pointerEvents: "none",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-3 mb-3">
                        <div>
                          <label className="d-flex align-items-center">
                            Date To
                          </label>
                        </div>
                        <div style={{ position: "relative" }}>
                          <DatePicker
                            selected={endDate}
                            onChange={(date) => setEndDate(date)}
                            className="form-control detail w-100"
                            wrapperClassName="w-100"
                            dateFormat="yyyy-MM-dd"
                            placeholderText="Select Date"
                            style={{ paddingRight: "36px" }}
                          />
                          <FontAwesomeIcon
                            icon={faCalendarAlt}
                            style={{
                              position: "absolute",
                              right: "12px",
                              top: "50%",
                              transform: "translateY(-50%)",
                              color: "#6c757d",
                              pointerEvents: "none",
                              fontSize: "14px",
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-3 radio-buttons mb-3 mt-3">
                        <label>
                          <input
                            type="radio"
                            name="viewOption"
                            value="viewReceipts"
                            checked={viewOption === "viewReceipts"}
                            onChange={handleOptionChange}
                          />
                          View Receipts
                        </label>
                        <label className="ms-3">
                          <input
                            type="radio"
                            name="viewOption"
                            value="viewCancelReceipts"
                            checked={viewOption === "viewCancelReceipts"}
                            onChange={handleOptionChange}
                          />
                          View Cancel Receipts
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div>

              {showTable && viewOption === "viewReceipts" && (
                <div className="fee-details-table mt-4">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Period</th>
                          <th>Name</th>
                          <th>Father's Name</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Bar Code No</th>
                          <th>Receipt Date</th>
                          <th>Receipt Amount</th>
                          <th>Discount Amount</th>
                          <th>Receipt No</th>
                          <th>Update</th>
                          <th>Cancel</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentReceipts.map((receipt, index) => (
                          <tr key={receipt.receiptId}>
                            <td>{offset + index + 1}</td>
                            <td>{receipt.period_month}</td>
                            <td>{receipt.studentname}</td>
                            <td>{receipt.fathername}</td>
                            <td>{receipt.classname}</td>
                            <td>{receipt.sectionname}</td>
                            <td>{receipt.barcode}</td>
                            <td>{formatReceiptDateForTable(receipt.receiptDate)}</td>
                            <td>{receipt.amount}</td>
                            <td>{receipt.discountamount}</td>
                            <td>
                              <a
                                href="#"
                                onClick={() =>
                                  handleReceiptLinkClick(receipt.receipt_no)
                                }
                              >
                                RC{receipt.receipt_no}
                              </a>
                            </td>
                            <td>
                              <a
                                href="#"
                                className="text-warning"
                                onClick={() => handleUpdateClick(receipt)}
                              >
                                Update
                              </a>
                            </td>
                            <td>
                              <a
                                href={`/cancel-receipt/${receipt.receiptId}`}
                                className="text-danger"
                                onClick={(e) => handleCancelClick(e, receipt)}
                              >
                                Cancel
                              </a>
                            </td>

                            <td>{receipt.payment_reference}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  {/* Pagination */}
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              )}

              {/* Cancel Modal */}
              {showCancelModal && selectedReceipt && (
                <div
                  className="modal show"
                  style={{ display: "block" }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Cancel Receipt</h5>
                      </div>
                      <div className="modal-body">
                        {/* Buttons at the top */}
                        <div className="row mb-2">
                          <div
                            className="col-12"
                            style={{ border: "1px solid #ccc" }}
                          >
                            <button
                              type="button"
                              className="btn btn-primary me-2"
                              style={{
                                "--bs-btn-padding-y": ".25rem",
                                "--bs-btn-padding-x": ".5rem",
                                "--bs-btn-font-size": ".75rem",
                                width: "150px",
                              }}
                              onClick={handleCancelSave} // Updated function name
                            >
                              Save
                            </button>
                            <button
                              type="button"
                              className="btn btn-primary me-2"
                              style={{
                                "--bs-btn-padding-y": ".25rem",
                                "--bs-btn-padding-x": ".5rem",
                                "--bs-btn-font-size": ".75rem",
                                width: "150px",
                              }}
                              onClick={handleCancelClear}
                            >
                              Clear
                            </button>
                            <button
                              type="button"
                              className="btn btn-danger me-2"
                              style={{
                                "--bs-btn-padding-y": ".25rem",
                                "--bs-btn-padding-x": ".5rem",
                                "--bs-btn-font-size": ".75rem",
                                width: "150px",
                              }}
                              onClick={handleCancelCloseButton}
                            >
                              Close
                            </button>
                          </div>
                        </div>
                        {/* Remark Field */}
                        <div className="form-group mt-3">
                          <label htmlFor="remark">Remark</label>
                          <textarea
                            id="remark"
                            className="form-control detail"
                            rows="3"
                            value={cancelRemark} // Bind remark value to state
                            onChange={(e) => setCancelRemark(e.target.value)} // Update state on input change
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showUpdateModal && selectedReceipt && (
                <div
                  className="modal show"
                  style={{ display: "block" }}
                  tabIndex="-1"
                  role="dialog"
                >
                  <div className="modal-dialog" role="document">
                    <div className="modal-content">
                      <div className="modal-header">
                        <h5 className="modal-title">Update Receipt</h5>
                      </div>
                      <div className="modal-body">
                        <form>
                          <div className="form-group">
                            <label>Receipt Date</label>
                            <input
                              type="date"
                              className="form-control detail"
                              name="receiptDate"
                              value={selectedReceipt.receiptDate}
                              onChange={handleInputChange}
                            />
                          </div>
                          <div className="form-group">
                            <label>Amount</label>
                            <input
                              type="number"
                              className="form-control detail"
                              name="amount"
                              value={selectedReceipt.amount}
                              onChange={handleInputChange}
                              disabled
                            />
                          </div>

                          {/* Reference Date Field */}
                          <div className="form-group">
                            <label>Reference Date</label>
                            <input
                              type="date"
                              className="form-control detail"
                              name="referenceDate"
                              value={selectedReceipt.referenceDate}
                              onChange={handleInputChange}
                            />
                          </div>

                          {/* Payment Method */}
                          <div className="form-group">
                            <label
                              htmlFor="paymentMethod"
                              className="form-label"
                            >
                              Payment Method
                            </label>
                            <Select
                              options={paymentMethodOptions}
                              classNamePrefix="react-select"
                              placeholder="Select Payment Method"
                              value={
                                paymentMethodOptions.find(
                                  (option) =>
                                    option.value ===
                                    selectedReceipt.paymentMethodId,
                                ) || null
                              }
                              onChange={(selectedOption) => {
                                const selectedValue = selectedOption
                                  ? selectedOption.value
                                  : null;

                                setSelectedReceipt((prev) => ({
                                  ...prev,
                                  paymentMethodId: selectedValue,
                                  bankId:
                                    selectedValue === 1 ? null : prev.bankId,
                                  accountNumber:
                                    selectedValue === 1
                                      ? ""
                                      : prev.accountNumber,
                                }));
                              }}
                            />
                          </div>

                          {/* Bank Name Dropdown */}
                          <div className="form-group">
                            <label>Bank</label>
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              name="bankId"
                              value={
                                bankOptions.find(
                                  (bank) =>
                                    bank.value === selectedReceipt.bankId,
                                ) || null
                              }
                              onChange={handleBankSelect}
                              options={bankOptions}
                              isDisabled={selectedReceipt.paymentMethodId === 1}
                            />
                          </div>

                          {/* Account Number Dropdown */}
                          <div className="form-group">
                            <label>Account Number</label>
                            <Select
                              className="react-select"
                              classNamePrefix="react-select"
                              name="accountNumber"
                              value={
                                selectedReceipt.accountNumber
                                  ? {
                                      label: selectedReceipt.accountNumber,
                                      value: selectedReceipt.accountNumber,
                                    }
                                  : null
                              }
                              onChange={(selectedOption) =>
                                handleSelectChange(
                                  selectedOption,
                                  "accountNumber",
                                )
                              }
                              options={accountDetails}
                              isDisabled={selectedReceipt.paymentMethodId === 1}
                            />
                          </div>
                        </form>
                      </div>
                      <div className="modal-footer">
                        <button
                          type="button"
                          className="btn btn-danger"
                          onClick={handleCloseReceiptModal}
                        >
                          Close
                        </button>
                        <button
                          type="button"
                          className="btn btn-primary"
                          onClick={handleSaveUpdate}
                        >
                          Update
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {showTable && viewOption === "viewCancelReceipts" && (
                <div className="cancelled-receipts-table mt-4">
                  <div className="table-responsive">
                    <table className="table table-bordered">
                      <thead>
                        <tr>
                          <th>Sr No</th>
                          <th>Period</th>
                          <th>Name</th>
                          <th>Father's Name</th>
                          <th>Class</th>
                          <th>Section</th>
                          <th>Bar Code No</th>
                          <th>Receipt Date</th>
                          <th>Receipt Amount</th>
                          <th>Discount Amount</th>
                          <th>Receipt No</th>
                          <th>Cancellation Remarks</th>
                          <th>Remarks</th>
                        </tr>
                      </thead>
                      <tbody>
                        {currentReceipts.map((receipt, index) => (
                          <tr key={receipt.receiptId}>
                            <td>{index + 1}</td>
                            <td>{receipt.period_month}</td>
                            <td>{receipt.studentname}</td>
                            <td>{receipt.fathername}</td>
                            <td>{receipt.classname}</td>
                            <td>{receipt.sectionname}</td>
                            <td>{receipt.barcode}</td>
                            <td>{formatReceiptDateForTable(receipt.receiptDate)}</td>
                            <td>{receipt.amount}</td>
                            <td>{receipt.discountamount}</td>
                            <td>RC{receipt.receipt_no}</td>
                            <td>{receipt.cancellation_remarks}</td>
                            <td>{receipt.payment_reference || "-"}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                  <ReactPaginate
                    previousLabel={"Previous"}
                    nextLabel={"Next"}
                    breakLabel={"..."}
                    breakClassName={"page-item"}
                    breakLinkClassName={"page-link"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination justify-content-center"}
                    pageClassName={"page-item"}
                    pageLinkClassName={"page-link"}
                    previousClassName={"page-item"}
                    previousLinkClassName={"page-link"}
                    nextClassName={"page-item"}
                    nextLinkClassName={"page-link"}
                    activeClassName={"active"}
                  />
                </div>
              )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FeeSearchPage;